import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import "./Sidebar.css";

function Sidebar({ isOpen, toggleSidebar }) {
  const [productDropdown, setProductDropdown] = useState(false);
  const [categoryDropdown, setCategoryDropdown] = useState(false);

  return (
    <>
      {/* OVERLAY */}
      <div
        className={`admin-overlay ${isOpen ? "show" : ""}`}
        onClick={toggleSidebar}
      ></div>

      {/* SIDEBAR */}
      <div className={`sidebar ${isOpen ? "active" : ""}`}>

        {/* LOGO */}
        <div className="admin-sidebar-logo">
          <img src={logo} alt="Pharmacy Admin Logo" />
        </div>

        <nav className="admin-sidebar-nav">

          <NavLink to="/admin" end onClick={toggleSidebar}>
            Dashboard
          </NavLink>

          {/* PRODUCTS */}
          <div className="admin-dropdown">
            <div
              className="admin-dropdown-title"
              onClick={() => setProductDropdown(!productDropdown)}
            >
              Products
              <span>{productDropdown ? "▲" : "▼"}</span>
            </div>
            {productDropdown && (
              <div className="admin-dropdown-content">
                <NavLink to="/admin/products/add" onClick={toggleSidebar}>
                  Add Product
                </NavLink>
                <NavLink to="/admin/products/view" onClick={toggleSidebar}>
                  View Products
                </NavLink>
              </div>
            )}
          </div>

          {/* CATEGORIES */}
          <div className="admin-dropdown">
            <div
              className="admin-dropdown-title"
              onClick={() => setCategoryDropdown(!categoryDropdown)}
            >
              Categories
              <span>{categoryDropdown ? "▲" : "▼"}</span>
            </div>
            {categoryDropdown && (
              <div className="admin-dropdown-content">
                <NavLink to="/admin/categories/add" onClick={toggleSidebar}>
                  Add Category
                </NavLink>
                <NavLink to="/admin/categories/view" onClick={toggleSidebar}>
                  View Categories
                </NavLink>
              </div>
            )}
          </div>

          <NavLink to="/admin/orders" onClick={toggleSidebar}>Orders</NavLink>
          <NavLink to="/admin/blog" onClick={toggleSidebar}>Blog</NavLink>
          <NavLink to="/admin/reviews" onClick={toggleSidebar}>Reviews</NavLink>
          <NavLink to="/admin/customers" onClick={toggleSidebar}>Customers</NavLink>
          <NavLink to="/admin/contact" onClick={toggleSidebar}>Contact</NavLink>
          <NavLink to="/admin/newsletter" onClick={toggleSidebar}>Newsletter</NavLink>

        </nav>
      </div>
    </>
  );
}

export default Sidebar;